exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btnmodulnastjedadd{\r\n    position: relative;\r\n    margin-right: 25px;\r\n}\r\n\r\n#modul-Forma .bg-primary-50 {\r\n    background-color: #ebedf7 !important;\r\n    width: 120%;\r\n    position: relative;\r\n    left: -100px;\r\n}\r\n\r\n#modul-Forma .modal-footer {\r\n    border-top-left-radius: 30px;\r\n    border-bottom-left-radius: 30px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/moduli-popis/moduli-popis.component.css
// module id = ../../../../../src/app/pages/virtualna-ucionica/moduli-popis/moduli-popis.component.css
// module chunks = main